import React from 'react';

import currencyFormat from 'components/Widgets/currencyFormat';
import affiliatePaymentStatuses from 'data/affiliate_payment_statuses';
import ExternalLink from 'components/Widgets/ExternalLink';
import downloadIcon from 'images/icons/invite/download.svg';

const statusHuman = (value) => affiliatePaymentStatuses.find((item) => item.value === value).label;

const columns = [
  {
    name: 'Payment Date',
    selector: (row) => row.attributes.payment_date_timestamp,
    cell: (row) => row.attributes.payment_date_formatted,
    sortable: true,
  },
  {
    name: 'Amount',
    selector: (row) => Number(row.attributes.amount),
    cell: (row) => currencyFormat(row.attributes.amount, { currency: row.attributes.currency.title }),
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    sortable: true,
    cell: (row) => statusHuman(row.attributes.status),
  },
  {
    name: 'Actions',
    sortable: false,
    width: '50px',
    cell: (row) => (
      <ExternalLink
        href={row.attributes.report}
        variant={null}
      >
        <img src={downloadIcon} alt="download" />
      </ExternalLink>
    ),
  },
];

export default columns;
